export default __webpack_public_path__ + "static/media/screenshot1.b3163179.png";